/**
 * Cache time constants for API queries
 * These values are used to configure stale time and cache time for TanStack Query
 */

// Time conversion constants
const MINUTES_TO_SECONDS = 60;
const SECONDS_TO_MILLISECONDS = 1000;

const SCALE_TIME_MULTIPLE = 5;
const CACHE_TIME_MULTIPLE = 10;

// Cache time constants in milliseconds
export const CACHE_TIMES = {
  // Stale time: How long data is considered fresh before it needs to be refetched
  STALE_TIME:
    SCALE_TIME_MULTIPLE * MINUTES_TO_SECONDS * SECONDS_TO_MILLISECONDS, // 5 minutes

  // Cache time: How long data stays in cache after it becomes unused
  CACHE_TIME:
    CACHE_TIME_MULTIPLE * MINUTES_TO_SECONDS * SECONDS_TO_MILLISECONDS, // 10 minutes
} as const;
